import type {ReactElement} from 'react';
import {useContext} from 'react';
import {formMakerContext} from '@FormMakerReact/form-maker.context';
import {EditorViewport} from '@FormMakerReact/form-maker.types';
import {useFormBackdropReselect} from '@FormMakerReact/hooks/use-form-backdrop-reselect';
import {FormMakerBottomBar} from '@FormMakerReact/layout/form-maker-bottom-bar/form-maker-bottom-bar';
import {FormMakerCanvas} from '@FormMakerReact/layout/form-maker-canvas/form-maker-canvas';
import {FormMakerHeader} from '@FormMakerReact/layout/form-maker-header/form-maker-header';
import {FormMakerRightPanel} from '@FormMakerReact/layout/form-maker-right-panel/form-maker-right-panel';
import type {FormMakerLayoutProps} from './form-maker-layout.types';
import styles from './form-maker-layout.module.scss';

export function FormMakerLayout({onCanvasContainerReady}: FormMakerLayoutProps): ReactElement {
  const {editor, state} = useContext(formMakerContext);
  useFormBackdropReselect(editor, state.formMode);
  const isDesktop = state.editorViewport === EditorViewport.DESKTOP;
  return (
    <main className={styles.layout}>
      <FormMakerHeader />
      <div className={styles.body}>
        <FormMakerCanvas onContainerReady={onCanvasContainerReady} />
        {renderRightPanel(isDesktop)}
      </div>
      {renderBottomBar(isDesktop)}
    </main>
  );
}

function renderRightPanel(isDesktop: boolean): ReactElement | null {
  if (!isDesktop) {
    return null;
  }
  return <FormMakerRightPanel />;
}

function renderBottomBar(isDesktop: boolean): ReactElement | null {
  if (isDesktop) {
    return null;
  }
  return <FormMakerBottomBar />;
}
